// Facebook Pixel - Tracking des événements
// Le pixel Facebook est installé dans public/index.html

// Fonction utilitaire pour vérifier si fbq est disponible
const isFbqAvailable = () => {
  return typeof window !== 'undefined' && typeof window.fbq === 'function'
}

// Événement Inscription terminée (CompleteRegistration)
export const trackCompleteRegistration = async (userEmail, eventSourceUrl = window.location.href) => {
  console.log('🎯 Tracking CompleteRegistration pour:', userEmail)
  
  if (!isFbqAvailable()) {
    console.error('❌ Facebook Pixel (fbq) non disponible')
    return false
  }

  try {
    // Utiliser le pixel Facebook directement
    window.fbq('track', 'CompleteRegistration', {
      content_name: 'EMDR Plus Registration',
      content_category: 'registration'
    })
    
    console.log('✅ Événement CompleteRegistration envoyé via Facebook Pixel')
    return true
  } catch (error) {
    console.error('❌ Erreur lors de l\'envoi de CompleteRegistration:', error)
    return false
  }
}

// Événement Achat (Purchase)
export const trackPurchase = async (value, currency = 'EUR', userEmail = null, eventSourceUrl = window.location.href) => {
  console.log('🎯 Tracking Purchase:', { value, currency, userEmail })
  
  if (!isFbqAvailable()) {
    console.error('❌ Facebook Pixel (fbq) non disponible')
    return false
  }

  try {
    // Utiliser le pixel Facebook directement
    window.fbq('track', 'Purchase', {
      value: value,
      currency: currency,
      content_name: 'EMDR Plus Subscription',
      content_category: 'subscription'
    })
    
    console.log('✅ Événement Purchase envoyé via Facebook Pixel')
    return true
  } catch (error) {
    console.error('❌ Erreur lors de l\'envoi de Purchase:', error)
    return false
  }
}

// Événement Paiement initié (InitiateCheckout)
export const trackInitiateCheckout = async (userEmail = null, eventSourceUrl = window.location.href) => {
  console.log('🎯 Tracking InitiateCheckout pour:', userEmail)
  
  if (!isFbqAvailable()) {
    console.error('❌ Facebook Pixel (fbq) non disponible')
    return false
  }

  try {
    // Utiliser le pixel Facebook directement
    window.fbq('track', 'InitiateCheckout', {
      content_name: 'EMDR Plus Subscription',
      content_category: 'subscription'
    })
    
    console.log('✅ Événement InitiateCheckout envoyé via Facebook Pixel')
    return true
  } catch (error) {
    console.error('❌ Erreur lors de l\'envoi de InitiateCheckout:', error)
    return false
  }
}

// Fonction de test pour vérifier si le pixel est chargé
export const testFacebookPixel = () => {
  console.log('🔍 Test du Facebook Pixel:')
  console.log('fbq disponible:', isFbqAvailable())
  
  if (isFbqAvailable()) {
    console.log('✅ Facebook Pixel correctement chargé')
    return true
  } else {
    console.error('❌ Facebook Pixel non disponible')
    return false
  }
} 